import { Star } from "lucide-react";

export default function Header() {
  return (
    <header 
      className="bg-astros-surface border-b border-astros-border"
      data-testid="header"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            {/* Astros Logo/Icon */}
            <div className="w-12 h-12 bg-astros-orange rounded-sm flex items-center justify-center">
              <Star className="w-8 h-8 text-white" fill="white" />
            </div>
            <div>
              <h1 className="font-bebas text-3xl sm:text-4xl tracking-tight text-white">
                HOUSTON ASTROS
              </h1>
              <p className="text-astros-muted text-sm font-ibm-plex">
                2026 Season Statistics
              </p>
            </div>
          </div>
          
          <div className="hidden md:flex items-center gap-2 text-xs text-astros-muted">
            <span className="w-2 h-2 bg-astros-success rounded-full animate-pulse"></span>
            <span>Auto-updating</span>
          </div>
        </div>
      </div>
    </header>
  );
}
